/**
 * Card Height Equalizer
 *
 * Equalises the heights of various card pairs for consistent visual appearance.
 * Supports loyalty points cards and WooCommerce dashboard cards.
 */
(function() {
	/**
	 * Generic function to equalize heights between two card elements.
	 *
	 * @param {string} selector1 - CSS selector for the first card.
	 * @param {string} selector2 - CSS selector for the second card.
	 * @param {number} minWidth - Minimum window width for equalization (default: 0).
	 * @returns {boolean} - True if equalization was performed, false otherwise.
	 */
	function equalizeCardHeights(selector1, selector2, minWidth = 0) {
		const card1 = document.querySelector(selector1);
		const card2 = document.querySelector(selector2);

		if (!card1 || !card2) {
			return false;
		}

		// Reset heights first to get natural height.
		card1.style.height = 'auto';
		card2.style.height = 'auto';

		// Check if window width meets minimum requirement.
		if (window.innerWidth < minWidth) {
			// Keep natural heights below breakpoint.
			return false;
		}

		// Ensure they are visible (avoid early measurement).
		const card1Height = card1.offsetHeight;
		const card2Height = card2.offsetHeight;

		const maxHeight = Math.max(card1Height, card2Height);

		// Apply equal height to both cards.
		card1.style.height = `${maxHeight}px`;
		card2.style.height = `${maxHeight}px`;

		return true;
	}

	/**
	 * Equalise heights of loyalty points cards.
	 * Only applies at window widths of 769px and above.
	 */
	function equaliseLoyaltyCardHeights() {
		return equalizeCardHeights(
			'.agend-loyalty-points-stats-card',
			'.agend-loyalty-points-available-card',
			769
		);
	}

	/**
	 * Equalise heights of WooCommerce dashboard cards.
	 * Only applies at window widths of 1201px and above.
	 */
	function equalizeDashboardCards() {
		return equalizeCardHeights(
			'body.woocommerce-dashboard .agend-membership-card',
			'body.woocommerce-dashboard .agend-loyalty-points-available-card',
			1201
		);
	}

	/**
	 * Run all card height equalizers.
	 */
	function equalizeAllCards() {
		equaliseLoyaltyCardHeights();
		equalizeDashboardCards();
	}

	/**
	 * Initialise card height equalisation with proper event handling.
	 */
	function initCardHeightEqualiser() {
		window.addEventListener('load', equalizeAllCards);

		// Run on resize with performance optimisation.
		window.addEventListener('resize', () => {
			requestAnimationFrame(equalizeAllCards);
		});

		// Handle dynamic content changes (like Elementor widgets).
		const observer = new MutationObserver(() => {
			// Debounce the observer to prevent excessive calls.
			clearTimeout(window.cardHeightTimeout);
			window.cardHeightTimeout = setTimeout(equalizeAllCards, 100);
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});
	}

	document.addEventListener('DOMContentLoaded', () => {
		initCardHeightEqualiser();
	});
})();
